import React, { useState, useEffect } from "react";
import {Button, Modal, Row, Spin, Form, Steps, notification, Icon, Col } from "antd";
import SelectField from "../../select-field";
import {companyService, systemService} from "../../../services";
import { legalEntityService } from '../../../services/legal-entity.service';
import RadioField from "../../radio-field";
import CreateLithuaniaLegalEntity from "./lithuania-legal-entity";
import CreateRusLegalEntity from "./rus-legal-entity";
import CreateBelarusLegalEntity from "./belarus-legal-entity";
import CreateKazakhstanLegalEntity from "./kazakhstan-legal-entity";
import i18n from '../../../i18n';

const getErrorDescription = (error) => {
    if (typeof error === "string") {
        return error;
    }
    if (error && typeof error.message === "string") {
        return error.message;
    }
    return String(error || "");
};

export default function ModalCreateNewLegalEntity({ isShow, setIsShow, onSuccess, setLoadingList, setStopListUpdate, isAgree }) {
    const [loading, setLoading] = useState(false);

    const [stepsList, setStepsList] = useState([]);
    const [currentStep, setCurrentStep] = useState(0);

    const [changeStepEvent, setChangeStepEvent] = useState('');
    const [createLegalEntityEvent, setCreateLegalEntityEvent] = useState(false);

    const [countryId, setCountryId] = useState(null);
    const [countryList, setCountryList] = useState([
        {
            id: 1,
            Name: i18n.t('constants.countries.1')
        },
        {
            Id: 3,
            Name: i18n.t('constants.countries.2')
        },
        {
            Id: 6,
            Name: i18n.t('constants.countries.3')
        }
    ]);

    const [purposeType, setPurposeType] = useState('default_purpose_type');
    const [purposeTypesList] = useState([
        {id: 'default_purpose_type', name: i18n.t('constants.purposeTypesList.default')},
        {id: 'consignor_purpose_type', name: i18n.t('constants.purposeTypesList.consignor')},
    ]);

    const [orgFormId, setOrgFormId] = useState(null);
    const [isProprietor, setIsProprietor] = useState(true);
    const [orgFormList, setOrgFormList] = useState([]);

    const [workWithNds, setWorkWithNds] = useState(null);
    const [taxId, setTaxId] = useState(null);
    const [taxType, setTaxType] = useState(null);
    const [reindexedTaxTypes, setReindexedTaxTypes] = useState([]);
    const [taxPercent, setTaxPercent] = useState(null);
    const [taxTypes, setTaxTypes] = useState([]);
    const [ndsList] = useState([
        {
            Id: 1,
            Name: i18n.t('main.yes')
        },
        {
            Id: 2,
            Name: i18n.t('main.no')
        }
    ]);

    const [fieldsErrors, setFieldsErrors] = useState({});

    let submitBtnStyle = {
        width: "200px",
        height: "43px",
        background: "#1CAA53",
        position: "static",
        borderRadius: "10px",
        color: "white",
        borderColor: "transparent",
    };

    // TODO убрал, пока доступны не все страны при создании юр.лиц
    // useEffect(() => {
    //   if (isShow) {
    //     setLoading(true);
    //
    //     systemService
    //         .getCountryList()
    //         .then(response => {
    //           setCountryList(response);
    //           setLoading(false);
    //         })
    //         .catch(errorMsg => {
    //           notification.error({
    //             message: "Получение списка стран",
    //             description: errorMsg,
    //           });
    //         });
    //   }
    // }, [isShow]);

    useEffect(() => {
        if (workWithNds === 2) {
            setTaxPercent(0);
            setTaxType('no_nds');
        } else {
            setTaxPercent(null);
            setTaxType(null);
        }
        setTaxId(null);
    }, [workWithNds]);

    useEffect(() => {
        if (isShow) {
            setTaxId(null);
            setTaxType(null);
            setTaxPercent(null);
            setWorkWithNds(null);

            legalEntityService.getTaxTypes()
            .then((data) => {
                setTaxTypes(data);

                let reindexedTaxTypes = {};

                data.forEach((item) => {
                    reindexedTaxTypes[item.id] = {
                        'type': item.alias,
                        'percent': item.rate
                    };
                });

                setReindexedTaxTypes(reindexedTaxTypes);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                notification.error({
                    message: i18n.t('components.notification.titles.getTaxTypes'),
                    description: error,
                });
            });
        }
    }, [isShow]);

    useEffect(() => {
        if (countryId) {
            setLoading(true);

            companyService
                .getOrganisationFormsList(countryId)
                .then((response) => {
                    setOrgFormList(response);
                    setLoading(false);
                })
                .catch((errorMsg) => {
                    notification.error({
                        message: i18n.t('components.notification.titles.getLegalEntityData'),
                        description: errorMsg,
                    });
                });
        }
    }, [countryId]);

    useEffect(() => {
        if (orgFormId) {
            let orgForm = orgFormList.find((value => {
                return value.Id === orgFormId;
            }));
            setIsProprietor(orgForm.IsProprietor);
        }
    }, [orgFormId]);

    const getFieldErrors = (fieldName) => {
        return typeof fieldsErrors[fieldName] !== "undefined"
            ? fieldsErrors[fieldName].reduce((fieldErrors, error) => {
                return fieldErrors + "; " + error;
            })
            : null;
    };

    const renderStepsList = () => {
        if (currentStep === 0) {
            return ( <Steps.Step title={i18n.t('modals.modalCreateNewLegalEntity.steps.step1')} />);
        }

        return stepsList.map((value, index) => {
            return (
                <Steps.Step title={value} key={`step${index}`}/>
            );
        });
    };

    const renderCreateFrom = () => {
        switch (countryId) {
            case 1:
                return (
                    <CreateRusLegalEntity
                        isActive={true}
                        orgFormId={orgFormId}
                        isProprietor={isProprietor}
                        workWithNds={workWithNds}
                        currentStep={currentStep}
                        setCurrentStep={setCurrentStep}
                        setStepsList={setStepsList}
                        changeStepEvent={changeStepEvent}
                        setChangeStepEvent={setChangeStepEvent}
                        createLegalEntityEvent={createLegalEntityEvent}
                        setCreateLegalEntityEvent={setCreateLegalEntityEvent}
                        setLoading={setLoading}
                        setShowModal={setIsShow}
                        countryId={countryId}
                        purposeType={purposeType}
                        taxType={taxType}
                        taxPercent={taxPercent}
                        isAgree={isAgree}
                    />
                );
            case 7:
                return (
                    <CreateLithuaniaLegalEntity
                        isActive={true}
                        orgFormId={orgFormId}
                        workWithNds={workWithNds}
                        currentStep={currentStep}
                        setCurrentStep={setCurrentStep}
                        setStepsList={setStepsList}
                        changeStepEvent={changeStepEvent}
                        setChangeStepEvent={setChangeStepEvent}
                        createLegalEntityEvent={createLegalEntityEvent}
                        setCreateLegalEntityEvent={setCreateLegalEntityEvent}
                        setLoading={setLoading}
                        countryId={countryId}
                        setIsShowParent={setIsShow}
                        isAgree={isAgree}
                    />
                );
            case 3:
                return (
                    <CreateBelarusLegalEntity
                        isActive={true}
                        orgFormId={orgFormId}
                        workWithNds={workWithNds}
                        currentStep={currentStep}
                        setCurrentStep={setCurrentStep}
                        setStepsList={setStepsList}
                        changeStepEvent={changeStepEvent}
                        setChangeStepEvent={setChangeStepEvent}
                        createLegalEntityEvent={createLegalEntityEvent}
                        setCreateLegalEntityEvent={setCreateLegalEntityEvent}
                        setLoading={setLoading}
                        countryId={countryId}
                        setIsShowParent={setIsShow}
                        isAgree={isAgree}
                    />
                );
            case 6:
                return (
                    <CreateKazakhstanLegalEntity
                        isActive={true}
                        orgFormID={orgFormId}
                        workWithNds={workWithNds}
                        currentStep={currentStep}
                        setCurrentStep={setCurrentStep}
                        setStepsList={setStepsList}
                        changeStepEvent={changeStepEvent}
                        setChangeStepEvent={setChangeStepEvent}
                        createLegalEntityEvent={createLegalEntityEvent}
                        setCreateLegalEntityEvent={setCreateLegalEntityEvent}
                        setLoading={setLoading}
                        setIsShowParent={setIsShow}
                        isAgree={isAgree}
                    />
                );
            default:
                return null;
        }
    };

    const createLegalEntity = () => {
        setCreateLegalEntityEvent(true);
    };

    const changeStep = (type) => {
        if (currentStep === 0) {
            setCurrentStep(1);
        } else {
            setChangeStepEvent(type);
        }
    };

    const isNextStepButtonDisabled = () => {
        if (currentStep === 0) {
            if (countryId) {
                if (countryId === 1) {
                    return !(orgFormId && workWithNds && taxType && taxPercent !== null);
                } else if (countryId === 3) {
                    return !(orgFormId && workWithNds);
                } else {
                    return !(orgFormId);
                }
            }
        }
    };

    return (
        <Modal
            title={i18n.t('modals.modalCreateNewLegalEntity.title')}
            cancelText={i18n.t('main.buttons.close')}
            className="modal-window"
            align={null}
            visible={isShow}
            onCancel={() => {
                setIsShow(false);
                setLoadingList(true);
                setStopListUpdate(false);
            }}
            footer={[
                <div style={{ marginTop: "10" }}>
                    {!loading && (
                        <div style={{ marginTop: "10" }}>
                            {currentStep !== 0 && (
                                <Button
                                    htmlType="submit"
                                    key="submitPrev"
                                    style={submitBtnStyle}
                                    onClick={() => changeStep("previous")}
                                    className="button-footer-previous"
                                    type="danger"
                                >
                                    <Icon
                                        style={{
                                            position: "absolute",
                                            paddingTop: "3px",
                                            display: "flex",
                                        }}
                                        type="left"
                                    />{" "}
                                    {i18n.t('main.buttons.previous')}
                                </Button>
                            )}
                            {currentStep === 0 || currentStep < stepsList.length ? (
                                <Button
                                    htmlType="submit"
                                    key="submitNext"
                                    style={submitBtnStyle}
                                    onClick={() => changeStep("next")}
                                    disabled={isNextStepButtonDisabled()}
                                    className="button-footer-next"
                                    type="primary"
                                >
                                    {i18n.t('main.buttons.next')}{" "}
                                    <Icon
                                        style={{
                                            position: "absolute",
                                            paddingLeft: "39px",
                                            paddingTop: "3px",
                                        }}
                                        type="right"
                                    />
                                </Button>
                            ) : (
                                <Button
                                    htmlType="submit"
                                    key="submit"
                                    style={submitBtnStyle}
                                    onClick={() => createLegalEntity()}
                                    type="primary"
                                    className="button-footer-create"
                                >
                                    {i18n.t('main.buttons.create')}
                                </Button>
                            )}
                        </div>
                    )}
                </div>,
            ]}
        >
            <Spin spinning={loading} tip={i18n.t('main.loadText.loading')}>
                <Form>
                    <Row>
                        <Steps
                            type="navigation"
                            size="small"
                            current={currentStep - 1}
                            className="site-navigation-steps"
                            style={{ marginBottom: "14px" }}
                        >
                            {renderStepsList()}
                        </Steps>
                        <br />
                        {currentStep === 0 ? (
                            <React.Fragment>
                                <Row>
                                    <Col lg={24} md={24} sm={24} xs={24}>
                                        <SelectField
                                            title={i18n.t('modals.modalCreateNewLegalEntity.fields.country.title')}
                                            name="country"
                                            selectedValue={countryId}
                                            values={countryList}
                                            getErrors={getFieldErrors}
                                            onChange={(value) => {
                                                setCountryId(value);

                                                setOrgFormId(null);
                                                setWorkWithNds(null);
                                            }}
                                            placeholder={i18n.t('modals.modalCreateNewLegalEntity.fields.country.placeholder')}
                                            notFoundText={i18n.t('modals.modalCreateNewLegalEntity.fields.country.notFoundText')}
                                            style={{ width: "100%" }}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12} md={12} sm={24} xs={24}>
                                        <RadioField
                                            title={i18n.t('modals.modalCreateNewLegalEntity.fields.orgForm.title')}
                                            values={orgFormList}
                                            onChange={(value) => {
                                                setOrgFormId(value.target.value);
                                            }}
                                            selectedValue={orgFormId}
                                            getErrors={getFieldErrors}
                                        />
                                    </Col>
                                    {(countryId === 1 || countryId === 3) && (
                                        <>
                                            <Col lg={12} md={12} sm={24} xs={24}>
                                                <RadioField
                                                    title={i18n.t('modals.modalCreateNewLegalEntity.fields.ndsList.title')}
                                                    values={ndsList}
                                                    onChange={(value) => setWorkWithNds(value.target.value)}
                                                    selectedValue={workWithNds}
                                                    getErrors={getFieldErrors}
                                                />
                                            </Col>
                                        </>
                                    )}
                                </Row>
                                <Row>
                                    <Col lg={12} md={12} sm={24} xs={24}>
                                        <RadioField
                                            title={i18n.t('modals.modalCreateNewLegalEntity.fields.purposeTypes.title')}
                                            values={purposeTypesList}
                                            onChange={(value) => setPurposeType(value.target.value)}
                                            selectedValue={purposeType}
                                            getErrors={getFieldErrors}
                                        />
                                    </Col>
                                    <Col lg={12} md={12} sm={24} xs={24}>
                                        {(countryId === 1 && workWithNds === 1) && <SelectField
                                            title={i18n.t('modals.modalCreateNewLegalEntity.fields.tax.title')}
                                            name="tax"
                                            selectedValue={taxId}
                                            values={taxTypes}
                                            getErrors={getFieldErrors}
                                            onChange={(value) => {
                                                setTaxId(value);
                                                setTaxType(reindexedTaxTypes[value].type);
                                                setTaxPercent(reindexedTaxTypes[value].percent);
                                            }}
                                            placeholder={i18n.t('modals.modalCreateNewLegalEntity.fields.tax.placeholder')}
                                            notFoundText={i18n.t('modals.modalCreateNewLegalEntity.fields.tax.notFoundText')}
                                            style={{ width: "100%" }}
                                        />}
                                    </Col>
                                </Row>
                            </React.Fragment>
                        ) : (
                            renderCreateFrom()
                        )}
                    </Row>
                </Form>
            </Spin>
        </Modal>
    );
}
